import { RootState } from '@store/store'
import { prop, propOr } from 'ramda'
import { createSelector } from 'reselect'

import {
  CALENDAR_EVENT,
  CALENDAR_EVENT_ALL,
  CALENDAR_EVENT_CREATE,
  CALENDAR_EVENT_LIST,
  CALENDAR_EVENT_LIST_STUDENT,
  GLOBAL_STATE,
} from '../constants/actionTypes'

const calendarSelector = (state: RootState) => prop(GLOBAL_STATE, state)

export const calendarEventAllSelector = createSelector(calendarSelector, data => data[CALENDAR_EVENT_ALL])
export const calendarEventOptionsSelector = createSelector(calendarEventAllSelector, selected => ({
  loading: selected.loading,
  error: selected.error,
  options: Array.isArray(selected.data)
    ? selected.data.map(item => ({ label: propOr('', 'title', item), value: item.id }))
    : [],
}))

export const calendarStudentEventAllSelector = createSelector(
  calendarSelector,
  data => data[CALENDAR_EVENT_LIST_STUDENT]
)

export const calendarEventSelector = createSelector(calendarSelector, data => data[CALENDAR_EVENT])

export const calendarEventCreateSelector = createSelector(calendarSelector, data => data[CALENDAR_EVENT_CREATE])

export const calendarEventListSelector = createSelector(calendarSelector, data => data[CALENDAR_EVENT_LIST])
